import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonJa from '../locales/ja/common.json';
import interviewJa from '../locales/ja/interview.json';
import dashboardJa from '../locales/ja/dashboard.json';
import errorsJa from '../locales/ja/errors.json';

import commonEn from '../locales/en/common.json';
import interviewEn from '../locales/en/interview.json';
import dashboardEn from '../locales/en/dashboard.json';
import errorsEn from '../locales/en/errors.json';

const resources = {
  ja: {
    common: commonJa,
    interview: interviewJa,
    dashboard: dashboardJa,
    errors: errorsJa,
  },
  en: {
    common: commonEn,
    interview: interviewEn,
    dashboard: dashboardEn,
    errors: errorsEn,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ja',
    defaultNS: 'common',
    ns: ['common', 'interview', 'dashboard', 'errors'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
  });

export default i18n;
